import PreviewInContext, { ThumbnailButton } from '@anm/components/PreviewInContext';
import SectionTitle from '@anm/components/video-landings/SectionTitle';
import { DEFAULT_WAVE_COLOR } from '@anm/constants/colors';
import { DEFAULT_THUMBNAIL_WIDTH } from '@anm/constants/videoLandings';
import isMobileOrIPad from '@anm/helpers/is/isMobileOrIPad';
import isUrlAbsolute from '@anm/helpers/is/isUrlAbsolute';
import { VideoSizes } from '@anm/hosting-player';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import vtConfig from '../../../../../config';
import { hostedVideoSelectors } from '../../../../../store/modules/hostedVideo';
import { landingsSelectors } from '../../../../../store/modules/landings';
import useEmailThumbPreview from '../../tabs/EmailTab/hooks/useEmailThumbPreview';

type EmailThumbProps = {
  sizes: VideoSizes;
  hostId: string;
  isWebinar?: boolean;
};

type EmailThumbContentProps = {
  sizes: VideoSizes;
  hostId: string;
  button: ThumbnailButton;
  landingUrl: string;
};

const Title = styled(SectionTitle)`
  text-align: left;
`;

const config = vtConfig();

const EmailThumbContent: FC<EmailThumbContentProps> = ({ sizes, hostId, button, landingUrl }) => {
  const ratio = sizes.width / sizes.height;
  const isVertical = ratio <= 1;
  const previewSrc = useEmailThumbPreview({ hostId, videoSizes: sizes });
  const placeholderHeight = Math.round(DEFAULT_THUMBNAIL_WIDTH / ratio);
  const videoSources = useSelector(hostedVideoSelectors.selectVideoSources);
  const isNoVideo = !videoSources?.length;
  const src = isNoVideo ? '' : previewSrc;

  return (
    <>
      {isMobileOrIPad() && <Title title="Email campaign" level={2} />}
      <PreviewInContext
        showPlaceholder={true}
        contextVariant="email"
        buttonUrl={landingUrl}
        showContextOnMobiles={false}
        {...{ src, isVertical, placeholderHeight, button }}
      />
    </>
  );
};

const EmailThumb: FC<EmailThumbProps> = ({ hostId, sizes, isWebinar }) => {
  const landingParams = useSelector(landingsSelectors.selectLandingParams);
  const playerColor = useSelector(hostedVideoSelectors.selectPlayerColor) || DEFAULT_WAVE_COLOR;

  if (!landingParams || !hostId) return null;

  const { playButton, link } = landingParams['emailCampaign'] || {};

  const playButtonState = playButton !== undefined ? playButton : true;
  const url = link || isWebinar ? `${config.urls.webinarUrl}${hostId}` : `${config.urls.videoLanding}${hostId}`;

  const landingUrl = isUrlAbsolute(url) ? url : `http://${url}`;

  return (
    <EmailThumbContent
      {...{ hostId, sizes, isWebinar, landingUrl }}
      button={{ enabled: playButtonState, color: playerColor }}
    />
  );
};

export default EmailThumb;
